export const COMPANY_PHONE_DISPLAY = '(888) 386-1251';
export const COMPANY_PHONE_TEL = '8883861251';
